/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AccessMutationRequest = {
  modelIds: Array<string>;
};

/** @internal */
export const AccessMutationRequest$inboundSchema: z.ZodType<
  AccessMutationRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  model_ids: z.array(z.string()),
}).transform((v) => {
  return remap$(v, {
    "model_ids": "modelIds",
  });
});
/** @internal */
export type AccessMutationRequest$Outbound = {
  model_ids: Array<string>;
};

/** @internal */
export const AccessMutationRequest$outboundSchema: z.ZodType<
  AccessMutationRequest$Outbound,
  z.ZodTypeDef,
  AccessMutationRequest
> = z.object({
  modelIds: z.array(z.string()),
}).transform((v) => {
  return remap$(v, {
    modelIds: "model_ids",
  });
});

export function accessMutationRequestToJSON(
  accessMutationRequest: AccessMutationRequest,
): string {
  return JSON.stringify(
    AccessMutationRequest$outboundSchema.parse(accessMutationRequest),
  );
}
export function accessMutationRequestFromJSON(
  jsonString: string,
): SafeParseResult<AccessMutationRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AccessMutationRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AccessMutationRequest' from JSON`,
  );
}
